import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

// Menu
export interface Menu {
   path?: string;
   title?: string;
   type?: string;
   icon?: string;
   badgeType?: string;
   badgeValue?: string;
   active?: boolean;
   megaMenu?: boolean;
   megaMenuType?: string; // small, medium, large
   bookmark?: boolean;
   children?: Menu[];
}

@Injectable({
   providedIn: 'root'
})
export class NavService {
   language: string = this.translate.currentLang;
   isFirstTime: boolean = true;

   subscription: Subscription;
   MENUITEMSALL: Array<Menu>;
   MENUITEMSMAIN: Array<Menu>;
   MENUITEMSBLOG: Array<Menu>;
   MENUITEMSCONTACT: Array<Menu>;
   MENUITEMSPOLICY: Array<Menu>;
   MENUITEMSABOUT: Array<Menu>;
   MENUITEMSSERVICES: Array<Menu>;
   MENUITEMSFAQ: Array<Menu>;

   constructor(private translate: TranslateService) {
      this.subscription = translate.stream("NAV_SERVICE").subscribe((menu: any) => {
         let menuAsArr = Array<Menu[]>();
        Object.keys(menu).map((key) => {
           menuAsArr.push(({[key]:menu[key]} as Menu[]));
           return menuAsArr;
        });
        
         menuAsArr.forEach((menuItem: Menu[]) => {
         if(this.isFirstTime === true){
            switch (Object.keys(menuItem)[0]) {
               case "MENUITEMSALL":
                  {
                     this.MENUITEMSALL = new Array<Menu>();
                     (menu["MENUITEMSALL"] as Array<Menu>).forEach(menuItem => {
                        if(menuItem.path?.indexOf("ua") > -1 || menuItem.path?.indexOf("en") > -1)   
                           this.MENUITEMSALL.push(menuItem);
                        else {
                           if(menuItem.type !== "sub")
                              menuItem.path = this.language + menuItem.path;
                           this.MENUITEMSALL.push(menuItem);
                        }
                     });
                  }
                  break;
               case "MENUITEMSMAIN":
                  {
                     this.MENUITEMSMAIN = new Array<Menu>();
                     (menu["MENUITEMSMAIN"] as Array<Menu>).forEach(menuItem => {
                        if(menuItem.path?.indexOf("ua") > -1 || menuItem.path?.indexOf("en") > -1)   
                           this.MENUITEMSMAIN.push(menuItem);
                        else {
                           if(menuItem.type !== "sub")
                              menuItem.path = this.language + menuItem.path;
                           this.MENUITEMSMAIN.push(menuItem);
                        }
                     });
                  }
                  break;
               case "MENUITEMSBLOG":
                  {
                     this.MENUITEMSBLOG = new Array<Menu>();
                     (menu["MENUITEMSBLOG"] as Array<Menu>).forEach(menuItem => {
                        if(menuItem.path?.indexOf("ua") > -1 || menuItem.path?.indexOf("en") > -1)   
                           this.MENUITEMSBLOG.push(menuItem);
                        else {
                           if(menuItem.type !== "sub")
                              menuItem.path = this.language + menuItem.path;
                           this.MENUITEMSBLOG.push(menuItem);
                        }
                     });
                  }
                  break;
               case "MENUITEMSCONTACT":
                  {
                     this.MENUITEMSCONTACT = new Array<Menu>();
                     (menu["MENUITEMSCONTACT"] as Array<Menu>).forEach(menuItem => {
                        if(menuItem.path?.indexOf("ua") > -1 || menuItem.path?.indexOf("en") > -1)   
                           this.MENUITEMSCONTACT.push(menuItem);
                        else {
                           if(menuItem.type !== "sub")
                              menuItem.path = this.language + menuItem.path;
                           this.MENUITEMSCONTACT.push(menuItem);
                        }
                     });
                  }
                  break;
               case "MENUITEMSPOLICY":
                  {
                     this.MENUITEMSPOLICY = new Array<Menu>();
                     (menu["MENUITEMSPOLICY"] as Array<Menu>).forEach(menuItem => {
                        if(menuItem.path?.indexOf("ua") > -1 || menuItem.path?.indexOf("en") > -1)   
                           this.MENUITEMSPOLICY.push(menuItem);
                        else {
                           if(menuItem.type !== "sub")
                              menuItem.path = this.language + menuItem.path;
                           this.MENUITEMSPOLICY.push(menuItem);
                        }
                     });
                  }
                  break;
               case "MENUITEMSABOUT":
                  {
                     this.MENUITEMSABOUT = new Array<Menu>();
                     (menu["MENUITEMSABOUT"] as Array<Menu>).forEach(menuItem => {
                        if(menuItem.path?.indexOf("ua") > -1 || menuItem.path?.indexOf("en") > -1)   
                           this.MENUITEMSABOUT.push(menuItem);
                        else {
                           if(menuItem.type !== "sub")
                              menuItem.path = this.language + menuItem.path;
                           this.MENUITEMSABOUT.push(menuItem);
                        }
                     });
                  }
                  break;
               case "MENUITEMSSERVICES":
                  {
                     this.MENUITEMSSERVICES = new Array<Menu>();
                     (menu["MENUITEMSSERVICES"] as Array<Menu>).forEach(menuItem => {
                        if(menuItem.path?.indexOf("ua") > -1 || menuItem.path?.indexOf("en") > -1)   
                           this.MENUITEMSSERVICES.push(menuItem);
                        else {
                           if(menuItem.type !== "sub")
                              menuItem.path = this.language + menuItem.path;
                           this.MENUITEMSSERVICES.push(menuItem);
                        }
                     });
                  }
                  break;
               case "MENUITEMSFAQ":
                  {
                     this.MENUITEMSFAQ = new Array<Menu>();
                     (menu["MENUITEMSFAQ"] as Array<Menu>).forEach(menuItem => {
                        if(menuItem.path?.indexOf("ua") > -1 || menuItem.path?.indexOf("en") > -1)   
                        this.MENUITEMSFAQ.push(menuItem);
                     else {
                        if(menuItem.type !== "sub")
                           menuItem.path = this.language + menuItem.path;
                        this.MENUITEMSFAQ.push(menuItem);
                     }
                     });
                  }
                  break;
            }
         }
         })
      });
   }

   ngOnInit() {
      
   }

   // getMenuContent(menu: any, menuName: string){
   //    this.MENUITEMSMAIN = new Array<Menu>();
   //    (menu[menuName] as Array<Menu>).forEach(menuItem => {
   //       menuItem.path = this.language + menuItem.path;
   //       this.MENUITEMSMAIN.push(menuItem);
   //    });
   // }
}
